import React from "react";

export default function PasswordChangedModal({ cancelModal }) {
  //styled
  return (
    <div className="send-modal-overlay">
      <div className="send-modal">
        <div className="blueBanner">
          <p className="fw-bold m-2 p-2 fontSize20">Password Changed</p>
        </div>
        <p>You have successfully changed your password.</p>

        <div className="send-modal-footer">
          <button
            onClick={cancelModal}
            className="pointer cancelButton fw-bold mx-2 px-3"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  );
}
